/**
 * ToastProvider - Wrapper Sonner pour notifications non-bloquantes
 * Remplace les alert() natifs dans le POS
 */
import { Toaster } from 'sonner';

export default function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      richColors
      duration={4000}
      closeButton
      toastOptions={{
        style: {
          fontSize: '15px',
        },
      }}
    />
  );
}
